import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CompanyMapper } from "./company.mapper";

import { Company } from "./company.model";
import { environment } from "environments/environment";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";

@Injectable()
export class CompanyRepository extends CrudAbstractRepository {
  getMapper(): any {
    return CompanyMapper.map;
  }

  getEndpoint(): string {
    return "company";
  }

  public listByOrganization(organizationId: number): Observable<Company[]> {
    return this.http
      .get<object[]>(
        `${environment.apiUrl}/organization/${organizationId}/company/list`,
      )
      .pipe(map((response) => response.map(this.getMapper())));
  }
}
